/**
 * Sound Effects Utility
 * 
 * Organic-sounding UI feedback using Web Audio API.
 */

let audioContext: AudioContext | null = null;

function getAudioContext(): AudioContext {
  if (!audioContext) {
    audioContext = new AudioContext();
  }
  return audioContext;
}

/**
 * Play a hollow wood knock sound.
 */
export function playTickSound(checked: boolean = true) {
  try {
    const ctx = getAudioContext();
    const now = ctx.currentTime;
    
    // Noise burst shaped into a knock
    const bufferSize = Math.floor(ctx.sampleRate * 0.06);
    const buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
    const data = buffer.getChannelData(0);
    
    // Generate decaying noise
    for (let i = 0; i < bufferSize; i++) {
      const t = i / bufferSize;
      const envelope = Math.exp(-t * 40); // Quick decay
      data[i] = (Math.random() * 2 - 1) * envelope;
    }
    
    const noise = ctx.createBufferSource();
    noise.buffer = buffer;
    
    // Bandpass to get hollow wood resonance
    const filter = ctx.createBiquadFilter();
    filter.type = 'bandpass';
    filter.frequency.value = checked ? 800 : 600;
    filter.Q.value = 8; // Resonant, hollow
    
    const gain = ctx.createGain();
    gain.gain.value = 0.4;
    
    noise.connect(filter);
    filter.connect(gain);
    gain.connect(ctx.destination);
    
    noise.start(now);
  } catch {
    // Fail silently
  }
}

/**
 * Play a mechanical keyboard click sound.
 */
export function playKeySound() {
  try {
    const ctx = getAudioContext();
    const now = ctx.currentTime;
    
    // Just filtered noise - simple and realistic
    const buffer = ctx.createBuffer(1, Math.floor(ctx.sampleRate * 0.012), ctx.sampleRate);
    const data = buffer.getChannelData(0);
    
    for (let i = 0; i < data.length; i++) {
      data[i] = (Math.random() * 2 - 1) * Math.exp(-i / (data.length * 0.1));
    }
    
    const noise = ctx.createBufferSource();
    noise.buffer = buffer;
    
    // Bandpass centered around 1200Hz - the "click" zone
    const filter = ctx.createBiquadFilter();
    filter.type = 'bandpass';
    filter.frequency.value = 1200;
    filter.Q.value = 2;
    
    const gain = ctx.createGain();
    gain.gain.value = 0.35;
    
    noise.connect(filter);
    filter.connect(gain);
    gain.connect(ctx.destination);
    
    noise.start(now);
  } catch {
    // Fail silently
  }
}

